export const MenuStyles = {
  button: {
    textTransform: 'none',
    minWidth: '78px',
    maxWidth: '150px',
    height: '28px',
    fontWeight: "400",
    borderRadius: '4px',
    border: '1px solid #e9eff4',
    color: '#22638D',
    padding: '6px',
    '& .MuiButton-endIcon': {
      marginLeft: '0px',
      '& >*:nth-of-type(1)': {
        fontSize: '30px',
      },
    },
    '&:hover': {
      background: "#fff",
      boxShadow: "rgba(0, 0, 0, 0.133) 0px 3.2px 7.2px 0px, rgba(0, 0, 0, 0.11) 0px 0.6px 1.8px 0px",
      border: '1px solid #22638D',
    },
  },
  menu: {
    '& .MuiPaper-root': {
      borderRadius: '4px',
      minWidth: '78px',
      maxWidth: '150px',
      boxShadow: 'rgba(0, 0, 0, 0.133) 0px 3.2px 7.2px 0px, rgba(0, 0, 0, 0.11) 0px 0.6px 1.8px 0px',
      border: '1px solid #22638D',
      color: '#22638D',

      '& .MuiList-root': {
        padding: 0,
        width: '100%',
      },
    },
  },
  menuItem: {
    color: '#22638D',
  },
};